// eslint-disable-next-line import/prefer-default-export
export const getCorrectTokenFromUser = (user) => {
  const { origin } = window;
  const isProd = !origin.includes('localhost') && !origin.includes('dev') && !origin.includes('acc');
  if (isProd) return user.accessToken;
  return user.idToken;
};
